import {z} from '@hono/zod-openapi';

/** Whose model computed a market's purchase price levels (T20-141867). */
export const priceReportPurchasePriceSourceSchema = z
  .enum(['tenant', 'alpha'])
  .openapi('PriceReportPurchasePriceSource', {
    description:
      'Whose model computed `purchasePrice`: the tenant configuration in the DMS or Alpha. ' +
      'Present whenever the market has purchase price levels.',
  });

export type PriceReportPurchasePriceSource = z.infer<typeof priceReportPurchasePriceSourceSchema>;
